'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.smoothScroll = exports.scrollUnlock = exports.scrollLock = exports.scrolledToBottom = exports.removeNoScriptFallbackTag = exports.removeEvent = exports.removeClass = exports.isNodeVisible = exports.isNodeDisabled = exports.injectStylesheet = exports.getHtmlNode = exports.getFocusableElements = exports.getDocumentRelativeCoordinates = exports.getContainingBlock = exports.focusGroupTitle = exports.findNode = exports.addEvent = exports.addClass = exports.$ = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * This document is the property of Nettoken Ltd.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * It is considered confidential and proprietary.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * This document may not be reproduced or transmitted in any form,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * in whole or in part, without the express written permission of
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Nettoken Ltd.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */


var _browser = require('./browser');

var BLOCK_LEVEL_DISPLAY_VALUES = ['block', 'list-item', 'table'];

var CSS_POSITION_CONTEXT_CHANGING_VALUES = ['absolute', 'fixed', 'relative'];

/*
 * Returns a reference to the element's nearest ancestor box
 * that satisfies the supplied condition.
 *
 * @param {Element} element
 * @param {Function} condition Receives current ancestor value.
 */
var getNearestAncestor = function getNearestAncestor(element, condition) {
  if (!element.parentNode) return element;

  var ancestor = element.parentNode;

  while (ancestor && !condition(ancestor)) {
    var _ancestor = ancestor,
        parentNode = _ancestor.parentNode;

    if (!parentNode || parentNode.nodeType !== 1) break;
    ancestor = parentNode;
  }

  return ancestor;
};

/*
 * Returns a reference to the element's nearest block container ancestor box
 * when `element` has `position: absolute` style.
 *
 * Source: https://www.w3.org/TR/CSS21/visuren.html#block-boxes
 */
var getNearestAncestorForAbsolute = function getNearestAncestorForAbsolute(element) {
  var isPositionValueCorrect = function isPositionValueCorrect(el) {
    var _getComputedStyle = getComputedStyle(el),
        position = _getComputedStyle.position;

    return CSS_POSITION_CONTEXT_CHANGING_VALUES.includes(position);
  };

  return getNearestAncestor(element, isPositionValueCorrect);
};

/*
 * Returns a reference to the element's nearest block container ancestor box.
 *
 * Source: https://www.w3.org/TR/CSS21/visuren.html#block-boxes
 */
var getNearestBlockContainerAncestor = function getNearestBlockContainerAncestor(element) {
  var isBlockContainer = function isBlockContainer(el) {
    var _getComputedStyle2 = getComputedStyle(el),
        display = _getComputedStyle2.display,
        position = _getComputedStyle2.position;

    return BLOCK_LEVEL_DISPLAY_VALUES.includes(display) || CSS_POSITION_CONTEXT_CHANGING_VALUES.includes(position);
  };

  return getNearestAncestor(element, isBlockContainer);
};

var $ = exports.$ = function $(str) {
  if (!str) throw new Error('Must be a string containing at least 1 character!');
  if (str.substr(0, 2) === '$ ') return document.querySelector(str.substr(2));
  if (str.startsWith('#')) return document.getElementById(str.substr(1));
  if (str.startsWith('.')) return document.getElementsByClassName(str.substr(1));
  return document.getElementsByTagName(str);
};

var addClass = exports.addClass = function addClass(node, className) {
  return node.classList.add(className);
};

var addEvent = exports.addEvent = function addEvent(node, eventName, callback) {
  var useCapture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (node.addEventListener) {
    node.addEventListener(eventName, callback, useCapture);
  } else if (node.attachEvent) {
    node.attachEvent('on' + eventName, callback);
  }
};

var findNode = exports.findNode = function findNode(fn) {
  var returnImmediately = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (returnImmediately) {
    var fnResult = typeof fn === 'function' ? fn() : $(fn.toString());
    return fnResult || undefined;
  }

  var step = 10;
  var timeout = 10000; // 10s
  var limit = timeout / step;
  var tries = 0;

  return new Promise(function (resolve) {
    var interval = setInterval(function () {
      tries += 1;

      var fnResult = typeof fn === 'function' ? fn() : $(fn.toString());
      if (fnResult) {
        clearInterval(interval);
        resolve(fnResult);
        return;
      }

      if (tries >= limit) clearInterval(interval);
    }, step);
  });
};

var focusGroupTitle = exports.focusGroupTitle = function focusGroupTitle(id) {
  findNode('#' + id).then(function (node) {
    var _node$getElementsByTa = node.getElementsByTagName('input'),
        _node$getElementsByTa2 = _slicedToArray(_node$getElementsByTa, 1),
        input = _node$getElementsByTa2[0];

    if (!input) return;
    input.focus();
  });
};

/*
 * Returns a reference to the element's containing block. We use the second
 * parameter to get containing block of an element we are about to inject
 * next to the existing element. Since it might have a different position
 * value than the sibling `element`, we mock it with this parameter.
 *
 * Source: https://www.w3.org/TR/CSS21/visudet.html#containing-block-details
 *
 * @param {Element} element
 * @param {String} elPosition Optionally override element position in computation.
 */
var getContainingBlock = exports.getContainingBlock = function getContainingBlock(element, elPosition) {
  if (!elPosition) elPosition = getComputedStyle(element).position;

  /*
   * 2. For other elements, if the element's position is 'relative' or 'static', the containing
   * block is formed by the content edge of the nearest block container ancestor box.
   */
  if (['relative', 'static'].includes(elPosition)) {
    return getNearestBlockContainerAncestor(element);
  }

  /*
   * 4. If the element has 'position: absolute', the containing block is established by the
   * nearest ancestor with a 'position' of 'absolute', 'relative' or 'fixed', in the following way:
   *
   * In the case that the ancestor is an inline element, the containing block is the bounding box
   * around the padding boxes of the first and the last inline boxes generated for that element.
   *
   * In CSS 2.1, if the inline element is split across multiple lines, the containing block is
   * undefined. Otherwise, the containing block is formed by the padding edge of the ancestor.
   *
   * If there is no such ancestor, the containing block is the initial containing block.
   */
  if (elPosition === 'absolute') {
    return getNearestAncestorForAbsolute(element);
  }

  // TODO needs to handle fixed, etc. per standards. Return element parent for now.
  return element.parentNode;
};

/*
 * Return coordinates relative to the document (page).
 *
 * @param {DOM} element Node whose position we want to obtain.
 */
var getDocumentRelativeCoordinates = exports.getDocumentRelativeCoordinates = function getDocumentRelativeCoordinates(element, isFixed) {
  var rect = element.getBoundingClientRect();
  var height = rect.height,
      width = rect.width;
  var _document = document,
      body = _document.body;

  var docEl = document.documentElement;

  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  var clientTop = docEl.clientTop || body.clientTop || 0;

  var _pageScroll = (0, _browser.pageScroll)(),
      scrollLeft = _pageScroll.x,
      scrollTop = _pageScroll.y;

  var _isFixed = isFixed || getComputedStyle(element).position === 'fixed';
  var left = Math.round(rect.left + scrollLeft - clientLeft);
  var top = _isFixed ? rect.top : Math.round(rect.top + scrollTop - clientTop);
  var bottom = top + height;
  var right = left + width;

  return {
    bottom: bottom,
    height: height,
    left: left,
    right: right,
    top: top,
    width: width
  };
};

var getFocusableElements = exports.getFocusableElements = function getFocusableElements() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;

  var selector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  return parent.querySelectorAll(selector);
};

var getHtmlNode = exports.getHtmlNode = function getHtmlNode() {
  var _findNode = findNode('html', true),
      _findNode2 = _slicedToArray(_findNode, 1),
      html = _findNode2[0];

  return html;
};

var injectStylesheet = exports.injectStylesheet = function injectStylesheet(id, getInnerHTML) {
  if ($('#' + id)) return;
  var style = document.createElement('style');
  style.type = 'text/css';
  style.id = id;
  style.innerHTML = getInnerHTML();
  document.head.appendChild(style);
};

/*
 * Returns true if element has attribute `disabled` or `disabled="true"`.
 */
var isNodeDisabled = exports.isNodeDisabled = function isNodeDisabled(node) {
  var disabled = node.getAttribute('disabled');
  if (disabled === null || disabled.toString() === 'false') return false;
  return true;
};

/*
 * Traverse upward the node tree to check if any parent is hidden, which
 * would mean its contents, including the node, are hidden as well.
 */
var isNodeVisible = exports.isNodeVisible = function isNodeVisible(node) {
  while (node) {
    var CSS = getComputedStyle(node);
    if (CSS.display === 'none' || node.getAttribute('aria-hidden') === 'true') {
      return false;
    }

    node = node.parentNode;
    if (node === document.body) break;
  }
  return true;
};

var removeClass = exports.removeClass = function removeClass(node, className) {
  node.classList.remove(className);
  if (!node.className) node.removeAttribute('class');
};

var removeEvent = exports.removeEvent = function removeEvent(node, eventName, callback) {
  var useCapture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (node.removeEventListener) {
    node.removeEventListener(eventName, callback, useCapture);
  } else if (node.detachEvent) {
    node.detachEvent('on' + eventName, callback);
  }
};

/*
 * Removes the <noscript> node from the DOM. Since we were able
 * to successfully load our application, it is reasonable to assume
 * the user has JavaScript turned on and this tag is no longer needed.
 */
var removeNoScriptFallbackTag = exports.removeNoScriptFallbackTag = function removeNoScriptFallbackTag() {
  var _document$getElements = document.getElementsByTagName('noscript'),
      _document$getElements2 = _slicedToArray(_document$getElements, 1),
      tag = _document$getElements2[0];

  if (tag) tag.remove();
};

var scrolledToBottom = exports.scrolledToBottom = function scrolledToBottom(el) {
  return el.scrollHeight <= el.scrollTop + el.offsetHeight;
};
var scrollLock = exports.scrollLock = function scrollLock() {
  return addClass(getHtmlNode(), 'scroll-lock');
};
var scrollUnlock = exports.scrollUnlock = function scrollUnlock() {
  return removeClass(getHtmlNode(), 'scroll-lock');
};

/*
 * Source: https://stackoverflow.com/a/25574313/4934026
 */
var smoothScroll = exports.smoothScroll = function smoothScroll(element, target, duration) {
  target = Math.round(target);
  duration = Math.round(duration);

  if (duration < 0) {
    return Promise.reject('Duration must be 0 or more.');
  }

  if (!duration) {
    element.scrollTop = target;
    return Promise.resolve();
  }

  var startTime = Date.now();
  var endTime = startTime + duration;

  var startTop = element.scrollTop;
  var distance = target - startTop;

  /*
   * Source: https://en.wikipedia.org/wiki/Smoothstep
   */
  var smoothStep = function smoothStep(start, end, point) {
    if (point <= start) return 0;
    if (point >= end) return 1;
    var x = (point - start) / (end - start); // interpolation
    return x * x * (3 - 2 * x);
  };

  return new Promise(function (resolve) {
    // This is to keep track of where the element's scrollTop is
    // supposed to be, based on what we're doing.
    var previousTop = element.scrollTop;

    // This is like a think function from a game loop.
    var scrollFrame = function scrollFrame() {
      // eslint-disable-line consistent-return
      if (element.scrollTop !== previousTop) {
        return resolve();
      }

      // Set the scrollTop for this frame.
      var now = Date.now();
      var point = smoothStep(startTime, endTime, now);
      var frameTop = Math.round(startTop + distance * point);
      element.scrollTop = frameTop;

      // We are done.
      if (now >= endTime) {
        return resolve();
      }

      // If we were supposed to scroll but didn't, then we
      // probably hit the limit, so consider it done; not
      // interrupted.
      if (element.scrollTop === previousTop && element.scrollTop !== frameTop) {
        return resolve();
      }

      previousTop = element.scrollTop;

      requestAnimationFrame(scrollFrame);
    };

    requestAnimationFrame(scrollFrame);
  });
};